module.exports = __webpack_public_path__ + "img/icon-11.bfe8bae9.png";